import { render, staticRenderFns } from "./AgendaModal.vue?vue&type=template&id=bb297fc2&scoped=true&"
import script from "./AgendaModal.vue?vue&type=script&lang=js&"
export * from "./AgendaModal.vue?vue&type=script&lang=js&"
import style0 from "./AgendaModal.vue?vue&type=style&index=0&id=bb297fc2&scoped=true&lang=css&"
import style1 from "./AgendaModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb297fc2",
  null
  
)

export default component.exports